import React from "react";
import {
  Flex,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

export default function Footer() {
  const textColor = useColorModeValue("gray.400", "white");
  const linkColor = useColorModeValue("orange.400", "orange.200");

  return (
    <Flex
      w={{ base: "100%", xl: "1170px" }}
      maxW={{ base: "90%", xl: "1170px" }}
      zIndex='1.5'
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "center",
      }}
      justifyContent='center'
      px={{ base: "0px", xl: "0px" }}
      pb='30px'
      mx='auto'>
      <Text
        color={textColor}
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}>
        {" "}
        <Text as="span" fontWeight="500" ms="4px">
          Fort Fitness Malta All Rights Reserved - Developed and Maintained by{" "}
          <Text
            as="a"
            href="http://axxsky.com/"
            target="_blank"
            rel="noopener noreferrer"
            color={linkColor}
          >
            Axxsky
          </Text>
        </Text>
      </Text>
    </Flex>
  );
}
